import { createReducer } from 'reduxsauce';
import { Types } from './types';
import { INITIAL_STATE } from './initialState';

export const faqsStart = state => ({
  ...state,
  isLoading: true,
  error: null,
});

export const faqsSuccess = (state, { data }) => ({
  ...state,
  data,
  isLoading: false,
});

export const faqsError = (state, { error }) => ({
  ...state,
  error,
  isLoading: false,
});

export const faqsCleanUp = () => INITIAL_STATE;

export const HANDLERS = {
  [Types.FAQS_START]: faqsStart,
  [Types.FAQS_SUCCESS]: faqsSuccess,
  [Types.FAQS_ERROR]: faqsError,
  [Types.FAQS_CLEAN_UP]: faqsCleanUp,
};

export default createReducer(INITIAL_STATE, HANDLERS);
